(function () {
  'use strict';

  var SEARCH_KEYS = [
    'schema_version', 'kicker', 'headline', 'ending', 'description', 'descriptionAccent',
    'placeholder', 'cta', 'x', 'y', 'zoom', 'shade', 'font', 'bodyFont', 'fontSize',
    'bodySize', 'bodyOffsetX', 'fontWeight', 'inputFont', 'buttonFont', 'lineHeight',
    'tracking', 'endingItalic', 'letterCase', 'textX', 'textY', 'textWidth', 'textAlign',
    'introColor', 'headingColor', 'endingColor', 'bodyColor', 'bodyAccentColor',
    'pillWidth', 'pillHeight', 'pillX', 'pillBottom', 'pillRadius', 'buttonWidth',
    'inputSize', 'buttonSize', 'pillColor', 'inputColor', 'placeholderColor',
    'buttonColor', 'buttonTextColor', 'featured_disc_visible'
  ];
  var RANGES = {
    x: [0, 100], y: [0, 100], zoom: [100, 180], shade: [0, 85], fontSize: [32, 84],
    bodySize: [9, 18], bodyOffsetX: [-60, 60], lineHeight: [0.8, 1.3], tracking: [-4, 4],
    textX: [0, 100], textY: [0, 100], textWidth: [55, 100], pillWidth: [60, 100],
    pillHeight: [52, 100], pillX: [0, 100], pillBottom: [12, 120], buttonWidth: [30, 60],
    inputSize: [11, 18], buttonSize: [8, 15]
  };
  var ENUMS = {
    font: ['didot', 'bodoni', 'cormorant', 'dm'],
    bodyFont: ['system', 'didot', 'bodoni', 'cormorant', 'dm'],
    inputFont: ['inherit', 'system', 'didot', 'bodoni', 'cormorant', 'dm', 'archivo'],
    buttonFont: ['inherit', 'system', 'didot', 'bodoni', 'cormorant', 'dm', 'archivo'],
    fontWeight: [400, 600, 700, 800], letterCase: ['none', 'uppercase', 'lowercase'],
    textAlign: ['left', 'center', 'right'], pillRadius: [0, 14, 18, 999]
  };
  var TEXT_LIMITS = {
    kicker: 60, headline: 60, ending: 60, description: 240,
    descriptionAccent: 120, placeholder: 100, cta: 24
  };
  var HOME_SEARCH_STARTERS = [
    'red maxi dress',
    'red heels for a wedding',
    'reformation vibes dress',
    'rust orange knitted co ord',
    'dress for a summer wedding',
    'black dress that hides bloating',
    "heels that won't kill me",
    'outfit for drinks with the girls',
    'white dress but not bridal',
    'birthday dress under £150',
    'winter wedding guest dress',
    'what to wear to the races',
    'date night outfit',
    'holiday clothes for a beach trip',
    'clean girl aesthetic outfit',
    'old money quiet luxury look',
    'coquette feminine dress',
    'statement going out top',
    'green dress for a wedding',
    'matching co ord set',
    'outfit for capri',
    'something for mykonos',
    'ibiza holiday outfit',
    'hen do dress',
    'girls trip outfit'
  ];
  var state = {
    hasSecond: false,
    slide: 0,
    searchConfig: null,
    homeSearchOpen: false,
    homeSearchClosing: false,
    homeSearchTouchX: null,
    homeSearchPhrases: HOME_SEARCH_STARTERS.map(function (text) {
      return { text: text, popularity: 2 };
    }),
    recognition: null,
    suppressHeroFocus: false
  };

  function root() {
    return document.querySelector('[data-gettmi-hero]');
  }

  function syncHomeHeroMode() {
    var mount = root();
    if (!mount) return;
    document.body.classList.toggle('gettmi-search-home-mode',
      mount.dataset.gettmiHeroMode === 'search' && window.matchMedia('(max-width: 749px)').matches);
  }

  function restoreHomeHero() {
    syncHomeHeroMode();
    layoutSearchHero();
    document.dispatchEvent(new CustomEvent('gettmi:home-hero-mode'));
  }

  function apiConfig() {
    var node = document.querySelector('[data-gettmi-supabase]');
    if (!node) return null;
    var url = String(node.dataset.supabaseUrl || '').replace(/\/+$/, '');
    var key = String(node.dataset.supabaseKey || '');
    return url && key ? { url: url, key: key } : null;
  }

  function storagePath(path) {
    var value = String(path || '');
    if (!value || value.length > 500 || value.indexOf('..') !== -1 || /^https?:/i.test(value)) return '';
    return value.split('/').filter(Boolean).map(encodeURIComponent).join('/');
  }

  function publicUrl(cfg, bucket, path, version, width, resize) {
    var safePath = storagePath(path);
    if (!cfg || !bucket || !safePath) return '';
    var params = ['width=' + encodeURIComponent(width || 1080), 'quality=72', 'resize=' + (resize === 'contain' ? 'contain' : 'cover')];
    if (version) params.push('v=' + encodeURIComponent(version));
    return cfg.url + '/storage/v1/render/image/public/' + encodeURIComponent(String(bucket)) + '/' +
      safePath + '?' + params.join('&');
  }

  function cleanQuery(value) {
    return typeof value === 'string' ? value.replace(/[\u0000-\u001f]/g, ' ').trim().slice(0, 120) : '';
  }

  function validSearchConfig(input) {
    if (!input || typeof input !== 'object' || Array.isArray(input) || input.schema_version !== 2) return false;
    if (!SEARCH_KEYS.every(function (key) { return Object.prototype.hasOwnProperty.call(input, key); })) return false;
    if (Object.keys(input).some(function (key) { return SEARCH_KEYS.indexOf(key) === -1; })) return false;
    if (Object.keys(RANGES).some(function (key) {
      var value = input[key];
      return typeof value !== 'number' || !Number.isFinite(value) || value < RANGES[key][0] || value > RANGES[key][1];
    })) return false;
    if (Object.keys(ENUMS).some(function (key) { return ENUMS[key].indexOf(input[key]) === -1; })) return false;
    if (Object.keys(TEXT_LIMITS).some(function (key) {
      return typeof input[key] !== 'string' || input[key].length > TEXT_LIMITS[key] || /[\u0000-\u0008\u000b-\u001f]/.test(input[key]);
    })) return false;
    if (SEARCH_KEYS.filter(function (key) { return /Color$/.test(key); }).some(function (key) {
      return typeof input[key] !== 'string' || !/^#[0-9a-f]{6}$/i.test(input[key]);
    })) return false;
    return typeof input.endingItalic === 'boolean' && typeof input.featured_disc_visible === 'boolean';
  }

  function setText(mount, selector, value) {
    var node = mount.querySelector(selector);
    if (node) node.textContent = String(value || '');
  }

  function setVariable(node, name, value) {
    node.style.setProperty('--' + name, String(value));
  }

  function layoutSearchHero() {
    var mount = root();
    var hero = mount && mount.querySelector('[data-gettmi-search-hero]');
    var c = state.searchConfig;
    if (!mount || !hero || !c || hero.hidden) return;
    var width = Math.max(1, hero.clientWidth || 390);
    var height = Math.max(1, hero.clientHeight || 374);
    var scale = Math.max(0.75, Math.min(width / 390, 1.4));
    var inset = 24 * scale;
    var pillWidth = Math.max(0, width - 32) * c.pillWidth / 100;
    var pillLeft = 16 + Math.max(0, width - 32 - pillWidth) * c.pillX / 100;
    var copyWidth = Math.max(0, width - inset * 2) * c.textWidth / 100;
    var copy = hero.querySelector('[data-gettmi-search-hero-copy]');
    var naturalHeight = copy ? copy.scrollHeight : 0;
    var copyAreaHeight = Math.max(0, height - inset - c.pillBottom - c.pillHeight - 20);
    var copyScale = naturalHeight ? Math.min(1, copyAreaHeight / naturalHeight) : 1;
    var typeScale = scale * copyScale;
    var copyLeft = inset + Math.max(0, width - inset * 2 - copyWidth) * c.textX / 100;
    var copyTop = inset + Math.max(0, copyAreaHeight - naturalHeight * copyScale) * c.textY / 100;
    var buttonWidth = Math.min(pillWidth - 64, Math.max(96, (pillWidth - 8) * c.buttonWidth / 100));
    setVariable(hero, 'hero-scale', scale);
    setVariable(hero, 'hero-type-scale', typeScale);
    setVariable(hero, 'hero-pill-width', pillWidth + 'px');
    setVariable(hero, 'hero-pill-left', pillLeft + 'px');
    setVariable(hero, 'hero-copy-width', copyWidth + 'px');
    setVariable(hero, 'hero-copy-left', copyLeft + 'px');
    setVariable(hero, 'hero-copy-top', copyTop + 'px');
    setVariable(hero, 'hero-button-width', buttonWidth + 'px');
    setVariable(hero, 'hero-intro-width', (28 * typeScale) + 'px');
    setVariable(hero, 'hero-intro-gap', (6 * typeScale) + 'px');
    setVariable(hero, 'hero-kicker-size', (14 * typeScale) + 'px');
    setVariable(hero, 'hero-kicker-spacing', (2 * typeScale) + 'px');
    setVariable(hero, 'hero-kicker-gap', (3 * typeScale) + 'px');
    setVariable(hero, 'hero-title-size', (c.fontSize * typeScale) + 'px');
    setVariable(hero, 'hero-title-tracking', (c.tracking * typeScale) + 'px');
    setVariable(hero, 'hero-description-size', (c.bodySize * typeScale) + 'px');
    setVariable(hero, 'hero-description-gap', (9 * typeScale) + 'px');
    setVariable(hero, 'hero-description-offset', (c.bodyOffsetX * scale) + 'px');
  }

  function legacyBanner(row, cfg) {
    var image = document.querySelector('[data-gettmi-legacy-home-banner-image]');
    var link = document.querySelector('[data-gettmi-legacy-home-banner]');
    if (!image || !link || !row || !row.image_path) return;
    var version = row.updated_at || row.id;
    image.src = publicUrl(cfg, 'banners', row.image_path, version, 1080);
    image.srcset = publicUrl(cfg, 'banners', row.image_path, version, 824) + ' 824w, ' + image.src + ' 1080w';
    image.alt = row.alt_text || row.title || 'GETTMI featured edit';
    if (row.link_url) link.href = row.link_url;
    link.hidden = false;
  }

  function showImageHero(row, cfg) {
    var mount = root();
    if (!mount) return;
    var legacy = mount.querySelector('[data-gettmi-hero-link-one]');
    var search = mount.querySelector('[data-gettmi-search-hero]');
    legacy.hidden = false;
    search.hidden = true;
    mount.classList.remove('is-search-mode');
    mount.dataset.gettmiHeroMode = 'image';
    syncHomeHeroMode();
    document.dispatchEvent(new CustomEvent('gettmi:home-hero-mode'));
    if (row && row.image_path) {
      var image = mount.querySelector('[data-gettmi-hero-image-one]');
      var version = row.updated_at || row.id;
      image.src = publicUrl(cfg, 'banners', row.image_path, version, 1080);
      image.srcset = publicUrl(cfg, 'banners', row.image_path, version, 824) + ' 824w, ' + image.src + ' 1080w';
      image.alt = row.alt_text || row.title || 'GETTMI weekly featured hero';
      if (row.link_url) legacy.href = row.link_url;
    }
  }

  function showSearchHero(row, cfg) {
    var mount = root();
    var c = row && row.hero_config;
    var backgroundPath = row && (row.background_image_path || row.background_path);
    if (!window.matchMedia('(max-width: 749px)').matches) {
      showImageHero(row, cfg);
      return;
    }
    if (!mount || row.render_mode !== 'search' || row.search_hero_enabled !== true || !validSearchConfig(c) || !backgroundPath) {
      showImageHero(row, cfg);
      return;
    }
    var search = mount.querySelector('[data-gettmi-search-hero]');
    var background = search.querySelector('[data-gettmi-search-hero-background]');
    // Preserve the full original before CSS framing. Storage's cover resize
    // crops width-only requests against the source height; contain does not.
    var url = publicUrl(cfg, 'banners', backgroundPath, row.updated_at || row.id, 1080, 'contain');
    if (!url) { showImageHero(row, cfg); return; }
    state.searchConfig = c;
    mount.querySelector('[data-gettmi-hero-link-one]').hidden = true;
    search.hidden = false;
    mount.classList.add('is-search-mode');
    mount.dataset.gettmiHeroMode = 'search';
    syncHomeHeroMode();
    document.dispatchEvent(new CustomEvent('gettmi:home-hero-mode'));
    search.dataset.headingFont = c.font;
    search.dataset.bodyFont = c.bodyFont;
    search.dataset.inputFont = c.inputFont === 'inherit' ? c.bodyFont : c.inputFont;
    search.dataset.buttonFont = c.buttonFont === 'inherit' ? c.bodyFont : c.buttonFont;
    search.dataset.textAlign = c.textAlign;
    search.dataset.letterCase = c.letterCase;
    background.src = url;
    background.srcset = publicUrl(cfg, 'banners', backgroundPath, row.updated_at || row.id, 824, 'contain') + ' 824w, ' + url + ' 1080w';
    background.sizes = '100vw';
    background.alt = row.alt_text || row.title || '';
    setText(search, '[data-gettmi-search-hero-kicker]', c.kicker);
    setText(search, '[data-gettmi-search-hero-headline]', c.headline);
    setText(search, '[data-gettmi-search-hero-ending]', c.ending);
    setText(search, '[data-gettmi-search-hero-description]', c.description);
    setText(search, '[data-gettmi-search-hero-description-accent]', c.descriptionAccent);
    setText(search, '[data-gettmi-search-hero-cta]', c.cta);
    var input = search.querySelector('[data-gettmi-search-hero-input]');
    input.placeholder = c.placeholder;
    input.setAttribute('aria-label', c.placeholder);
    [
      ['hero-image-x', c.x + '%'], ['hero-image-y', c.y + '%'], ['hero-image-zoom', c.zoom / 100],
      ['hero-shade', c.shade / 100], ['hero-shade-end', c.shade / 400], ['hero-font-size', c.fontSize + 'px'], ['hero-body-size', c.bodySize + 'px'],
      ['hero-body-offset-x', c.bodyOffsetX + 'px'], ['hero-font-weight', c.fontWeight],
      ['hero-line-height', c.lineHeight], ['hero-tracking', c.tracking + 'px'],
      ['hero-intro-color', c.introColor], ['hero-heading-color', c.headingColor],
      ['hero-ending-color', c.endingColor], ['hero-body-color', c.bodyColor],
      ['hero-body-accent-color', c.bodyAccentColor], ['hero-pill-height', c.pillHeight + 'px'],
      ['hero-pill-bottom', c.pillBottom + 'px'], ['hero-pill-radius', c.pillRadius + 'px'],
      ['hero-input-size', c.inputSize + 'px'], ['hero-button-size', c.buttonSize + 'px'],
      ['hero-pill-color', c.pillColor], ['hero-input-color', c.inputColor],
      ['hero-placeholder-color', c.placeholderColor], ['hero-button-color', c.buttonColor],
      ['hero-button-text-color', c.buttonTextColor]
    ].forEach(function (entry) { setVariable(search, entry[0], entry[1]); });
    search.querySelector('[data-gettmi-search-hero-ending]').classList.toggle('is-italic', c.endingItalic);
    var muse = mount.querySelector('[data-gettmi-search-muse]');
    muse.hidden = !c.featured_disc_visible;
    legacyBanner(row, cfg);
    window.requestAnimationFrame(layoutSearchHero);
  }

  function setSlide(index) {
    var mount = root();
    if (!mount) return;
    var next = index === 1 && state.hasSecond ? 1 : 0;
    state.slide = next;
    mount.querySelectorAll('[data-gettmi-hero-slide]').forEach(function (slide) {
      slide.classList.toggle('is-active', Number(slide.dataset.gettmiHeroSlide) === next);
    });
    var toggle = mount.querySelector('[data-gettmi-toggle-hero]');
    toggle.setAttribute('aria-label', next === 0 ? 'Show next banner' : 'Back to first banner');
    mount.querySelector('[data-gettmi-hero-toggle-vertical]').hidden = next === 1;
    document.body.classList.toggle('gettmi-hero-slide-two', next === 1);
  }

  function fetchRows(cfg, query) {
    return window.fetch(cfg.url + '/rest/v1/home_banners?' + query, {
      headers: { apikey: cfg.key, Authorization: 'Bearer ' + cfg.key }
    }).then(function (response) {
      if (!response.ok) throw new Error('banners');
      return response.json();
    });
  }

  function hydrate() {
    var mount = root();
    var cfg = apiConfig();
    if (!mount || !cfg) return;
    var current = 'select=id,slot,image_path,background_image_path,title,alt_text,link_url,sort_order,created_at,updated_at,render_mode,search_hero_enabled,hero_config' +
      '&is_active=eq.true&slot=in.(hero_slide_1,hero_slide_2)&order=slot.asc,sort_order.desc,created_at.desc';
    var legacy = 'select=id,slot,image_path,title,alt_text,link_url,sort_order,created_at' +
      '&is_active=eq.true&slot=in.(hero_slide_1,hero_slide_2)&order=slot.asc,sort_order.desc,created_at.desc';
    fetchRows(cfg, current).catch(function () { return fetchRows(cfg, legacy); }).then(function (rows) {
      rows = Array.isArray(rows) ? rows : [];
      var first = rows.find(function (row) { return row.slot === 'hero_slide_1'; });
      var second = rows.find(function (row) { return row.slot === 'hero_slide_2'; });
      if (first) showSearchHero(first, cfg);
      if (second && second.image_path) {
        state.hasSecond = true;
        var slide = mount.querySelector('[data-gettmi-hero-slide="1"]');
        var image = mount.querySelector('[data-gettmi-hero-image-two]');
        image.src = publicUrl(cfg, 'banners', second.image_path, second.updated_at || second.id, 1080);
        image.alt = second.alt_text || second.title || 'GETTMI second featured hero';
        if (second.link_url) mount.querySelector('[data-gettmi-hero-link-two]').href = second.link_url;
        slide.hidden = false;
        mount.querySelector('[data-gettmi-toggle-hero]').disabled = false;
        mount.querySelector('[data-gettmi-toggle-hero]').setAttribute('aria-disabled', 'false');
      }
    }).catch(function () {
      /* Seeded Liquid content remains complete when the public reader is unavailable. */
    });
  }

  function homeSearchElements(mount) {
    var section = mount && mount.closest('.shopify-section');
    var scope = section || document;
    return {
      takeover: scope.querySelector('[data-gettmi-home-search-takeover]'),
      form: scope.querySelector('[data-gettmi-home-search-form]'),
      composer: scope.querySelector('[data-gettmi-home-search-composer]'),
      input: scope.querySelector('[data-gettmi-home-search-input]'),
      count: scope.querySelector('[data-gettmi-home-search-count]'),
      ghost: scope.querySelector('[data-gettmi-home-search-ghost]'),
      suggestions: scope.querySelector('[data-gettmi-home-search-suggestions]'),
      status: scope.querySelector('[data-gettmi-home-search-status]'),
      voice: scope.querySelector('[data-gettmi-home-search-voice]'),
      heroInput: mount && mount.querySelector('[data-gettmi-search-hero-input]')
    };
  }

  function homeSearchViewportMetrics(viewport, fallbackHeight) {
    var height = viewport && Number(viewport.height) > 0 ? Number(viewport.height) : Number(fallbackHeight || 0);
    var top = viewport && Number(viewport.offsetTop) > 0 ? Number(viewport.offsetTop) : 0;
    return {
      height: Math.max(320, Math.round(height || 320)),
      top: Math.max(0, Math.round(top))
    };
  }

  function syncHomeSearchViewport(mount) {
    if (!state.homeSearchOpen) return;
    var el = homeSearchElements(mount);
    if (!el.takeover) return;
    var metrics = homeSearchViewportMetrics(window.visualViewport, window.innerHeight);
    el.takeover.style.setProperty('--gettmi-home-search-viewport-height', metrics.height + 'px');
    el.takeover.style.setProperty('--gettmi-home-search-viewport-top', metrics.top + 'px');
  }

  function rankHomeSearchSuggestions(value) {
    var query = String(value || '').toLowerCase().trim();
    if (!query) return { suggestions: [], ghost: null };
    var lastWord = query.split(' ').pop();
    var ranked = state.homeSearchPhrases.map(function (phrase) {
      var text = String(phrase.text || '').toLowerCase();
      var tier = text.indexOf(query) === 0
        ? 3
        : text.split(' ').some(function (word) { return word.indexOf(lastWord) === 0; })
          ? 2
          : text.indexOf(query) >= 0 ? 1 : 0;
      return { text: phrase.text, popularity: Number(phrase.popularity || 1), tier: tier };
    }).filter(function (phrase) {
      return phrase.tier && phrase.text.toLowerCase() !== query;
    }).sort(function (left, right) {
      return right.tier - left.tier ||
        right.popularity - left.popularity ||
        left.text.length - right.text.length;
    });
    var suggestions = ranked.slice(0, 5).map(function (phrase) { return phrase.text; });
    var ghost = ranked.find(function (phrase) {
      return phrase.text.toLowerCase().indexOf(query) === 0 && phrase.text.length > query.length;
    });
    return {
      suggestions: suggestions,
      ghost: ghost ? { full: ghost.text, completion: ghost.text.slice(query.length) } : null
    };
  }

  function renderHomeSearch(mount) {
    var el = homeSearchElements(mount);
    if (!el.input || !el.suggestions || !el.ghost) return;
    var value = el.input.value.slice(0, 120);
    var typeahead = rankHomeSearchSuggestions(value);
    el.count.textContent = value.length + ' / 120';
    el.input.setAttribute('aria-expanded', typeahead.suggestions.length ? 'true' : 'false');
    el.ghost.replaceChildren();
    el.ghost.dataset.full = typeahead.ghost ? typeahead.ghost.full : '';
    if (typeahead.ghost) {
      var typed = document.createElement('span');
      typed.className = 'gettmi-home-search-composer__ghost-typed';
      typed.textContent = value;
      el.ghost.append(typed, document.createTextNode(typeahead.ghost.completion));
    }
    el.suggestions.replaceChildren();
    if (!typeahead.suggestions.length) return;
    if (typeahead.ghost) {
      var hint = document.createElement('p');
      hint.className = 'gettmi-home-search-suggestions__hint';
      hint.textContent = 'SWIPE RIGHT TO COMPLETE';
      el.suggestions.appendChild(hint);
    }
    typeahead.suggestions.forEach(function (phrase) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'gettmi-home-search-suggestions__row';
      button.dataset.gettmiHomeSearchSuggestion = phrase;
      button.textContent = phrase;
      el.suggestions.appendChild(button);
    });
  }

  function acceptHomeSearchGhost(mount) {
    var el = homeSearchElements(mount);
    var full = el.ghost && el.ghost.dataset.full;
    if (!full) return;
    el.input.value = full;
    renderHomeSearch(mount);
    el.input.focus();
  }

  function submitHomeSearch(mount, value) {
    var el = homeSearchElements(mount);
    var query = cleanQuery(value);
    if (!query) {
      if (!state.homeSearchOpen) openHomeSearch(mount, '');
      else el.input.focus();
      return;
    }
    var destination = new URL(el.form.action, window.location.href);
    destination.searchParams.set('q', query);
    window.location.assign(destination.toString());
  }

  function openHomeSearch(mount, seed) {
    if (!window.matchMedia('(max-width: 749px)').matches || state.homeSearchOpen || state.homeSearchClosing) return;
    var el = homeSearchElements(mount);
    if (!el.takeover || !el.input) return;
    state.homeSearchOpen = true;
    // On iOS, letting the underlying hero field keep focus gives Safari time to
    // pan the layout viewport before the takeover textarea receives focus.
    // Blur it synchronously; pointerdown below prevents that initial focus path.
    if (el.heroInput && document.activeElement === el.heroInput) el.heroInput.blur();
    if (el.status) { el.status.hidden = true; el.status.textContent = ''; }
    el.input.value = String(seed || '').slice(0, 120);
    el.takeover.hidden = false;
    el.takeover.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gettmi-home-search-open');
    syncHomeSearchViewport(mount);
    renderHomeSearch(mount);
    // Keep this inside the initiating pointer/focus event. Mobile Safari only
    // opens the keyboard reliably for focus that preserves user activation.
    el.input.focus({ preventScroll: true });
    window.requestAnimationFrame(function () {
      el.takeover.classList.add('is-visible');
    });
  }

  function closeHomeSearch(mount) {
    if (!state.homeSearchOpen || state.homeSearchClosing) return;
    var el = homeSearchElements(mount);
    state.homeSearchClosing = true;
    if (state.recognition) {
      try { state.recognition.abort(); } catch (error) { /* Best effort. */ }
    }
    if (el.input) el.input.blur();
    el.takeover.classList.remove('is-visible');
    el.takeover.classList.add('is-closing');
    window.setTimeout(function () {
      el.takeover.hidden = true;
      el.takeover.classList.remove('is-closing');
      el.takeover.setAttribute('aria-hidden', 'true');
      el.input.value = '';
      if (el.heroInput) el.heroInput.value = '';
      el.takeover.style.removeProperty('--gettmi-home-search-viewport-height');
      el.takeover.style.removeProperty('--gettmi-home-search-viewport-top');
      document.documentElement.classList.remove('gettmi-home-search-open');
      renderHomeSearch(mount);
      state.homeSearchOpen = false;
      state.homeSearchClosing = false;
      var returnButton = mount.querySelector('[data-gettmi-search-hero-submit]');
      if (returnButton) returnButton.focus({ preventScroll: true });
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 240);
  }

  function warmHomeSearchPhrases() {
    var cfg = apiConfig();
    if (!cfg) return;
    window.fetch(cfg.url + '/functions/v1/search-v2', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: cfg.key,
        Authorization: 'Bearer ' + cfg.key
      },
      body: JSON.stringify({ mode: 'phrases' })
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (data) {
      if (!data || !Array.isArray(data.phrases)) return;
      var merged = new Map();
      state.homeSearchPhrases.concat(data.phrases).forEach(function (phrase) {
        if (phrase && typeof phrase.text === 'string') {
          merged.set(phrase.text.toLowerCase(), {
            text: phrase.text.slice(0, 120),
            popularity: Number(phrase.popularity || 1)
          });
        }
      });
      state.homeSearchPhrases = Array.from(merged.values());
      if (state.homeSearchOpen) renderHomeSearch(root());
    }).catch(function () {
      /* Bundled app phrases remain usable when the public reader is unavailable. */
    });
  }

  function startHomeVoiceSearch(mount) {
    var el = homeSearchElements(mount);
    var Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!Recognition) {
      el.status.textContent = 'Voice search isn’t supported in this browser. You can still type your search.';
      el.status.hidden = false;
      return;
    }
    if (state.recognition) {
      try { state.recognition.stop(); } catch (error) { /* Best effort. */ }
      return;
    }
    var recognition = new Recognition();
    state.recognition = recognition;
    recognition.lang = document.documentElement.lang || 'en-GB';
    recognition.continuous = false;
    recognition.interimResults = true;
    recognition.onstart = function () {
      el.voice.classList.add('is-listening');
      el.voice.setAttribute('aria-pressed', 'true');
      el.voice.setAttribute('aria-label', 'Stop listening');
      el.status.textContent = 'Listening… tap the mic to stop.';
      el.status.hidden = false;
    };
    recognition.onresult = function (event) {
      var transcript = Array.from(event.results).map(function (result) {
        return result[0] && result[0].transcript || '';
      }).join(' ').trim();
      if (transcript) {
        el.input.value = transcript.slice(0, 120);
        renderHomeSearch(mount);
      }
    };
    recognition.onend = function () {
      state.recognition = null;
      el.voice.classList.remove('is-listening');
      el.voice.setAttribute('aria-pressed', 'false');
      el.voice.setAttribute('aria-label', 'Search by voice');
      if (el.status.textContent === 'Listening… tap the mic to stop.') {
        el.status.textContent = el.input.value.trim() ? 'Ready. Tap search to find your edit.' : 'No speech heard. Try again or type your search.';
      }
    };
    recognition.onerror = function (event) {
      el.status.textContent = event && event.error === 'not-allowed'
        ? 'Microphone access wasn’t allowed. You can type your search instead.'
        : 'Voice search couldn’t start. Try again or type your search.';
      el.status.hidden = false;
      recognition.onend();
    };
    try { recognition.start(); } catch (error) { recognition.onend(); }
  }

  function bindHomeSearch(mount) {
    var el = homeSearchElements(mount);
    if (!el.takeover || !el.form || !el.input || !el.heroInput || el.takeover.dataset.gettmiSearchBound === 'true') return;
    el.takeover.dataset.gettmiSearchBound = 'true';
    el.heroInput.addEventListener('pointerdown', function (event) {
      if (!window.matchMedia('(max-width: 749px)').matches || state.homeSearchOpen || state.homeSearchClosing) return;
      event.preventDefault();
      openHomeSearch(mount, el.heroInput.value);
    });
    el.heroInput.addEventListener('focus', function () {
      if (!state.suppressHeroFocus) openHomeSearch(mount, el.heroInput.value);
    });
    el.heroInput.addEventListener('input', function () {
      if (!state.homeSearchOpen) openHomeSearch(mount, el.heroInput.value);
    });
    el.form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitHomeSearch(mount, el.input.value);
    });
    el.input.addEventListener('input', function () { renderHomeSearch(mount); });
    el.takeover.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeHomeSearch(mount);
      } else if (event.key === 'Tab') {
        var focusable = Array.from(el.takeover.querySelectorAll('.gettmi-home-search-sheet textarea, .gettmi-home-search-sheet button'))
          .filter(function (node) { return !node.disabled && node.getClientRects().length; });
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
    el.input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeHomeSearch(mount);
      } else if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        submitHomeSearch(mount, el.input.value);
      }
    });
    el.suggestions.addEventListener('click', function (event) {
      var button = event.target.closest('[data-gettmi-home-search-suggestion]');
      if (!button) return;
      submitHomeSearch(mount, button.dataset.gettmiHomeSearchSuggestion);
    });
    el.takeover.querySelectorAll('[data-gettmi-home-search-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeHomeSearch(mount); });
    });
    el.voice.addEventListener('click', function () { startHomeVoiceSearch(mount); });
    el.takeover.querySelector('[data-gettmi-home-search-camera]').addEventListener('click', function () {
      if (!window.GettmiAppGate || !window.GettmiAppGate.isEnabled('girlmaths')) {
        el.status.textContent = 'Photo matching lives in GETTMI a Dupe in the app. Type a description here to search the web edit.';
        el.status.hidden = false;
      }
    });
    el.composer.addEventListener('touchstart', function (event) {
      state.homeSearchTouchX = event.touches && event.touches[0] ? event.touches[0].clientX : null;
    }, { passive: true });
    el.composer.addEventListener('touchend', function (event) {
      var endX = event.changedTouches && event.changedTouches[0] ? event.changedTouches[0].clientX : null;
      if (state.homeSearchTouchX != null && endX != null && endX - state.homeSearchTouchX > 24) {
        acceptHomeSearchGhost(mount);
      }
      state.homeSearchTouchX = null;
    }, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () { syncHomeSearchViewport(mount); }, { passive: true });
      window.visualViewport.addEventListener('scroll', function () { syncHomeSearchViewport(mount); }, { passive: true });
    }
    if (window.matchMedia('(max-width: 749px)').matches) warmHomeSearchPhrases();
  }

  document.addEventListener('click', function (event) {
    var mount = root();
    if (!mount || !event.target.closest) return;
    if (event.target.closest('[data-gettmi-toggle-hero]')) {
      if (state.hasSecond) setSlide(state.slide === 0 ? 1 : 0);
    }
  });

  function boot() {
    var mount = root();
    if (!mount || mount.dataset.gettmiBooted === 'true') return;
    mount.dataset.gettmiBooted = 'true';
    // Liquid already knows the initial mode; do not wait for home_banners.
    syncHomeHeroMode();
    var form = mount.querySelector('[data-gettmi-search-hero-form]');
    if (form) form.addEventListener('submit', function (event) {
      var input = form.querySelector('[data-gettmi-search-hero-input]');
      var query = cleanQuery(input.value);
      event.preventDefault();
      if (state.homeSearchOpen) submitHomeSearch(mount, query);
      else if (query) submitHomeSearch(mount, query);
      else openHomeSearch(mount, '');
    });
    bindHomeSearch(mount);
    if ('ResizeObserver' in window) new ResizeObserver(layoutSearchHero).observe(mount);
    window.addEventListener('resize', restoreHomeHero, { passive: true });
    hydrate();
    layoutSearchHero();
  }

  window.GettmiHomeHeroTest = {
    cleanQuery: cleanQuery,
    validSearchConfig: validSearchConfig,
    homeSearchViewportMetrics: homeSearchViewportMetrics
  };
  window.addEventListener('pageshow', restoreHomeHero);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
